import React, { useState } from "react";
import { Snackbar, Alert } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { CircularProgress } from "@mui/material";
import CustomPhoneInput from "components/CustomPhoneInput";

const FotterContactForm = () => {
  const [isLoading, setIsLoading] = React.useState(false);

  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const [phone, setPhone] = useState();
  const [phoneError, setPhoneError] = useState(true);

  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isLoading) return;

    setIsLoading(true); // Start loading

    const form = e.target;
    const name = form[0].value;
    const firstname = form[1].value;
    const email = form[2].value;
    const subject = form[3].value;
    const message = form[6].value;

    if (!email || !subject || !message || !phone || !phoneError) {
      setSnackbar({
        open: true,
        message: !phoneError
          ? "Le numéro de téléphone n'est pas valide."
          : "Merci de remplir tous les champs obligatoires.",
        severity: "error",
      });
      setIsLoading(false);
      return;
    }

    try {
      const res = await fetch("https://tourbuslive.fr/contact-form/send.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Site-Secret": process.env.REACT_APP_CONTACT_SECRET,
        },
        body: JSON.stringify({
          name: `${firstname} ${name}`,
          email,
          phone,
          subject,
          message,
        }),
      });

      const result = await res.json();

      setSnackbar({
        open: true,
        message: result.message || "Message envoyé !",
        severity: result.success ? "success" : "error",
      });

      if (result.success) form.reset();
    } catch (err) {
      setSnackbar({
        open: true,
        message: "Erreur lors de l'envoi du message.",
        severity: "error",
      });
      console.error(err);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  return (
    <div style={{ textAlign: "center", maxWidth: "470px" }}>
      <h3
        style={{
          color: "#c84653",
          fontWeight: 700,
          fontSize: isSmall ? 16 : 18,
          marginBottom: "10px",
        }}
      >
        Besoin d'infos ? On vous rappelle !
      </h3>

      <form
        onSubmit={handleSubmit}
        style={{
          display: "grid",
          gridTemplateColumns: isSmall ? "1fr" : "1fr 1fr",
          gap: 12,
          maxWidth: 700,
          marginInline: "auto",
          padding: isSmall ? "0" : "0.5rem",
        }}
      >
        {/* Row 1: Nom/Prénom */}
        <input type="text" placeholder="Nom" style={inputStyle} />
        <input type="text" placeholder="Prénom" style={inputStyle} />

        {/* Row 2: Email/Phone */}
        <input type="email" placeholder="Adresse Email *" style={inputStyle} />
        <CustomPhoneInput
          required
          value={phone}
          onChange={(newPhone) => setPhone(newPhone)}
          setPhoneError={setPhoneError}
          label="N° de téléphone"
          placeholder="Entrez votre numéro de téléphone"
          sx={{ width: "100%" }}
          contactPage
        />

        {/* Row 3: Sujet */}
        <input
          type="text"
          placeholder="Sujet *"
          style={{
            ...inputStyle,
            gridColumn: "1 / -1",
          }}
        />

        {/* Row 4: Message */}
        <textarea
          placeholder="Votre message *"
          rows="3"
          style={{
            ...inputStyle,
            gridColumn: "1 / -1",
            minHeight: "80px",
            resize: "vertical",
          }}
        ></textarea>
        <div
          style={{
            gridColumn: "1 / -1",
            textAlign: "center",
            marginTop: "8px",
          }}
        >
          <button
            type="submit"
            disabled={isLoading}
            style={{
              ...buttonStyle,
              width: "100%",
              maxWidth: "300px",
              opacity: isLoading ? 0.7 : 1,
              pointerEvents: isLoading ? "none" : "auto",
              position: "relative",
            }}
          >
            {isLoading ? (
              <CircularProgress size={22} color="inherit" />
            ) : (
              "Rappelez-moi"
            )}
          </button>
        </div>
      </form>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

const inputStyle = {
  backgroundColor: "#faf7f5",
  padding: "12px 16px",
  fontSize: 14,
  borderRadius: 6,
  border: "1px solid #ddd",
  width: "100%",
  boxSizing: "border-box",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  transition: "border-color 0.3s ease, box-shadow 0.3s ease",
  outline: "none",
  ":focus": {
    borderColor: "#c84653",
    boxShadow: "0 0 0 2px rgba(200, 70, 83, 0.2)",
  },
};

const buttonStyle = {
  backgroundColor: "#c84653",
  color: "white",
  fontWeight: 600,
  fontSize: 14,
  borderRadius: 6,
  border: "none",
  padding: "10px 24px",
  cursor: "pointer",
  boxShadow: "0 2px 4px rgba(200, 70, 83, 0.2)",
  transition:
    "background-color 0.3s ease, transform 0.2s ease, box-shadow 0.2s ease",
  ":hover": {
    backgroundColor: "#b03848",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 6px rgba(200, 70, 83, 0.3)",
  },
  ":active": {
    transform: "translateY(1px)",
    boxShadow: "0 1px 2px rgba(200, 70, 83, 0.3)",
  },
};

export default FotterContactForm;
